module.exports = __webpack_public_path__ + "static/media/empty-state-history.3126957f.svg";